import { html, ovl, SYSFormElement } from "../../../src"
import { FormGetControl } from "../../../src/library/forms/formapi"
import { SYSFormField } from "../../../src/library/forms/sysformelement"

const FormFieldGetPwVisibleCheckbox = (): {
  VisiblePw: SYSFormField
} => {
  return {
    VisiblePw: <SYSFormField>{
      control: "checkbox",
      value: false,
      ui: {
        labelTranslationKey: "SYSLoginPasswordVisible",
        checkedValue: true,
      },
    },
  }
}

export class SYSFormPasswordVisibility extends SYSFormElement {
  async init() {
    this.formHandling = {
      formType: "SYSPasswordVisibility",
      forceOverwrite: true,
      creation: {
        autoInitFormFields: { ...FormFieldGetPwVisibleCheckbox() },
      },
    }

    await super.init()
  }
  async getUI() {
    if (!this.state.ovl.app.enablePasswordVisibility) {
      return null
    }
    return html` ${FormGetControl(this.formState.fields.VisiblePw)} `
  }
}
